// extracted by mini-css-extract-plugin
export default {"faq":"faq_faq__n1TWZ","faqs":"faq_faqs__OdruW","faq_elem":"faq_faq_elem__eXTVk","label":"faq_label__W+cW8","label_num":"faq_label_num__5aeUa","f56":"faq_f56__IiAkg"};